<script setup>
import { computed } from 'vue';

const props = defineProps({
  count: { type: [Number, String], default: 0 },
  variant: {
    type: String,
    default: 'default',
    validator: value => ['default', 'ruby'].includes(value),
  },
  compact: { type: Boolean, default: false },
});

const normalizedCount = computed(() => {
  const count = Number(props.count);
  return Number.isFinite(count) && count > 0 ? count : 0;
});

const displayCount = computed(() =>
  normalizedCount.value > 99 ? '99+' : String(normalizedCount.value)
);

const badgeClasses = computed(() => {
  if (props.variant === 'ruby') {
    return props.compact
      ? 'h-4 min-w-4 px-0.5 text-[10px] font-semibold leading-none text-white bg-n-ruby-9'
      : 'h-5 min-w-5 px-1 text-xxs font-medium leading-3 text-white bg-n-ruby-9';
  }

  return 'h-5 min-w-5 px-1 text-xxs font-medium leading-3 text-n-slate-12 bg-n-slate-4 dark:bg-n-slate-5';
});
</script>

<template>
  <span
    v-if="normalizedCount > 0"
    data-test-id="sidebar-unread-badge"
    class="inline-grid place-items-center rounded-full flex-shrink-0"
    :class="badgeClasses"
  >
    {{ displayCount }}
  </span>
  <span v-else class="hidden" />
</template>
